export default __webpack_public_path__ + "static/AI-6804458343f7d0297e943c7bee574da0.png";